import dayjs from "dayjs";

export const materialColumns = (navigate) => [
  {
    title: "Product Name",
    dataIndex: "productName",
    key: "productName",
    render: (key) => {
      return <div>{key || "-"}</div>;
    },
  },
  {
    title: "Product Code",
    dataIndex: "productCode",
    key: "productCode",
    render: (key) => {
      return <div>{key || "-"}</div>;
    },
  },
  {
    title: "Images",
    dataIndex: "images",
    key: "images",
    render: (key) => {
      return <div>{key || "-"}</div>;
    },
  },
  {
    title: "Videos",
    dataIndex: "videos",
    key: "videos",
    render: (key) => {
      return <div>{key || "-"}</div>;
    },
  },
  {
    title: "PDFs",
    dataIndex: "pdfs",
    key: "pdfs",
    render: (key) => {
      return <div>{key || "-"}</div>;
    },
  },
  {
    title: "FAQs",
    dataIndex: "faqs",
    key: "faqs",
    render: (key) => {
      return <div>{key || "-"}</div>;
    },
  },
  {
    title: "Date Created",
    dataIndex: "dateCreated",
    key: "dateCreated",
    render: (key) => {
      return <div>{key ? dayjs(key).format("DD/MM/YYYY") : "-"}</div>;
    },
  },
  {
    title: "Action",
    key: "action",
    render: (row) => {
      return (
        <div className="action-icons">
          <div className="grid2 d-flex">
            <button
              className="manage"
              style={{
                fontFamily: "Gotham",
                fontWeight: "400 ",
              }}
              onClick={() => {
                navigate("/ai-campaigns/manage-material", { state: row });
              }}
            >
              Manage
            </button>
          </div>
        </div>
      );
    },
  },
];
